export const CardVariant = {
  REGULAR: 'regular'
}
